import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import { cn } from './cn';

export type InputSize = 'sm' | 'md' | 'lg';

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  inputSize?: InputSize;
  invalid?: boolean;
  leadingAddon?: ReactNode;
  trailingAddon?: ReactNode;
  wrapperClassName?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { inputSize = 'md', invalid, leadingAddon, trailingAddon, wrapperClassName, className, ...rest },
  ref
) {
  return (
    <div
      className={cn(
        'ui-input',
        `ui-input--${inputSize}`,
        invalid && 'ui-input--invalid',
        wrapperClassName
      )}
    >
      {leadingAddon ? (
        <span className="ui-input__addon ui-input__addon--leading">{leadingAddon}</span>
      ) : null}
      <input
        ref={ref}
        className={cn('ui-input__control', className)}
        aria-invalid={invalid || undefined}
        {...rest}
      />
      {trailingAddon ? (
        <span className="ui-input__addon ui-input__addon--trailing">{trailingAddon}</span>
      ) : null}
    </div>
  );
});
